<template>
  <section>
    <nav class="columns">
      <div class="column">
        <b-tabs
          v-model="activeTab"
          :animated="false"
          class="boarder-tabs"
          destroyOnHide
          multiline
          expanded
        >
          <b-tab-item
            :label="$t('attributes.regular')"
            :disabled="showTypeLoading"
          >
            <b-field>
              <b-select v-model="bannerShowType" @load="showTypeLoading">
                <option value="線別>出發日期">線別>出發日期(先至後)</option>
                <option value="線別">線別</option>
                <option value="出發日期">出發日期(先至後)</option>
              </b-select>
              <b-button
                type="is-primary"
                size="is-medium"
                @click="onSetShowType"
                style="margin: -7px 20px;"
              >
                {{ $t('attributes.update') }}
              </b-button>
            </b-field>
          </b-tab-item>
          <b-tab-item :label="$t('attributes.area')">
            <recently-hot-area-list></recently-hot-area-list>
          </b-tab-item>
          <b-tab-item :label="$t('attributes.travel_group')">
            <recently-hot-travel-groups></recently-hot-travel-groups>
          </b-tab-item>
        </b-tabs>
      </div>
    </nav>
  </section>
</template>

<script>
import { HOME_RECENTLY_HOT_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import RecentlyHotAreaList from '@/components/home/RecentlyHotAreaList'
import RecentlyHotTravelGroups from '@/components/home/RecentlyHotTravelGroups'

export default {
  name: 'RecentlyHot',
  components: { RecentlyHotTravelGroups, RecentlyHotAreaList },
  data() {
    return {
      showTypeLoading: false,
      activeTab: 0,

      bannerShowType: '',
      areas: []
    }
  },
  mounted() {
    this.loadShowType()
  },
  methods: {
    async loadShowType() {
      this.BannerShowType = true
      const api = `${HOME_RECENTLY_HOT_API}/ShowType`
      const res = await this.axios.get(api)
      this.bannerShowType = res.data.message
      this.showTypeLoading = false
    },
    async onSetShowType() {
      try {
        this.showTypeLoading = true
        const api = `${HOME_RECENTLY_HOT_API}/ShowType`
        const parma = {
          recently_hot_show_type: this.bannerShowType
        }
        const res = await this.axios.put(api, parma)
        if (res.data.message === 'OK') {
          notifyService.success(this.$t('attributes.update_succeed'))
        } else {
          notifyService.update_error()
        }
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.showTypeLoading = false
      }
    }
  }
}
</script>
